import React, { Fragment } from "react";
import { Table } from "reactstrap";

const SkillsTable = ({ data }) => {
  console.log(data);

  const rows = data.map((item) => (
    <>
      {/* <p>Primary Skills</p> */}

      {/* <p>Skill Group : <span>{item.skillGroup}</span></p>
           <p>Skill  :  <span>{item.skill}</span></p> */}
      {/* <p>Skill Group : <span>{item.skillGroup}</span></p>
           <p>Skill  :  <span>{item.skill}</span></p> */}

      <tr style={{width:"25.25rem"}}>
        <td>
          <p>{item.skillGroup}</p>
        </td>
        <td>
          <p>{item.skill}</p>
        </td>
      </tr>
      </>
  ));
  return (
    <>
      <Table bordered style={{ "border-style": "solid" }}>
        <thead>
          <tr>
            <th style={{'width':"25.25rem"}}>
              <h6>Skill Group</h6>
            </th>
            <th>
              <h6>Skill</h6>
            </th>
          </tr>
        </thead>
        <tbody>
          <Fragment>{rows}</Fragment>
        </tbody>
      </Table>
    </>
  );
};
export default SkillsTable;
